export default __webpack_public_path__ + "static/media/88.92c8d669.jpg";